import { CaseReducer } from '@reduxjs/toolkit';
import { SortOptionsEnum } from 'common/features/VirtualList/VirtualList.config';
import { SortState } from '../../SortGroup/store/sort.types';

export const createSortCollectorSelectionCaseReducer =
  <State extends SortState>(): CaseReducer<State> =>
  (state) => {
    state.currentSort = SortOptionsEnum.COLLECTOR_SELECTION;
  };
